import { locationUpdateApi } from "../../api/location/locationUpdateApi"

type PayloadShape = Parameters<typeof locationUpdateApi>[0]

export async function locationUpdateService(payload: PayloadShape, token: string) {
	return await locationUpdateApi(payload, token)
}
